import * as React from 'react';
/**
 * The default loading indicator only displaying "Loading".
 */
export const DefaultLoadingIndicator = () => React.createElement("div", null, "Loading");
DefaultLoadingIndicator.displayName = 'DefaultLoadingIndicator';
//# sourceMappingURL=DefaultLoadingIndicator.js.map